import { Modal, type ModalConfig, type ModalReturn } from '@arco-design/web-vue'
import { assign } from 'lodash-es'

/**
 * 使用模态框的自定义 hook。
 *
 * @returns {object} 包含打开和关闭模态框的方法。
 * @property {Function} openModal - 打开模态框的方法。
 * @property {Function} closeModal - 关闭模态框的方法。
 */
export default function useModal() {
  const modal: Record<string, ModalReturn | null> = {}
  const defaultInstanceId = 'modalInstance'
  const baseOptions = ref<Pick<ModalConfig, 'modalClass' | 'footer'>>({
    modalClass: 'stp-modal',
    footer: false,
  })

  function openModal(options: ModalConfig, modalId = defaultInstanceId): void {
    const config = assign({}, baseOptions.value, options)
    modal[modalId] = Modal.open(config)
  }

  function openWarningModal(options: ModalConfig, modalId = defaultInstanceId) {
    modal[modalId] = Modal.warning(options)
  }

  function closeModal(modalId = defaultInstanceId) {
    if (modal[modalId] && typeof modal[modalId].close === 'function') {
      modal[modalId].close()
    }
  }

  return {
    openModal,
    openWarningModal,
    closeModal,
  }
}
